import {
  type TableCellProps,
  type TableColumnHeaderProps,
  type TextProps,
  Td,
  Text as ChakraText,
  Th,
} from '@chakra-ui/react';

export function LabelText(props: TextProps) {
  return (
    <ChakraText
      fontWeight={400}
      fontSize="10px"
      lineHeight="100%"
      letterSpacing="0%"
      color="#8E8E93"
      {...props}
    />
  );
}

export function ValueText(props: TextProps) {
  return (
    <ChakraText
      fontWeight={400}
      fontSize="20px"
      lineHeight="100%"
      letterSpacing="0%"
      color="#373F41"
      {...props}
    />
  );
}

export function SectionTitle(props: TextProps) {
  return (
    <ChakraText
      fontWeight={500}
      fontSize="16px"
      lineHeight="24px"
      letterSpacing="0%"
      color="#373F41"
      {...props}
    />
  );
}

export function HeaderCell(props: TableColumnHeaderProps) {
  return (
    <Th
      py="8px"
      bg="#E5E5EA !important"
      fontWeight={500}
      fontSize="9px"
      color="#373F41"
      textTransform="none"
      textAlign="center"
      {...props}
    />
  );
}

export function BodyCell(props: TableCellProps) {
  return (
    <Td
      py="8px"
      fontWeight={400}
      fontSize="13px"
      color="#373F41"
      textAlign="center"
      {...props}
    />
  );
}
